import { Unless, When } from 'react-if';
import { Title } from './Title';
import { MultiList } from './MultiList';
import { NestedMultiList } from './NestedMultiList';
import { FilterDefn } from '../index';
import { Divider } from '../../../theme';

export type FilterGroupProps = {
    title?: string;
    hideDivider?: boolean;
    type: 'multiList' | 'nestedMultiList';
    options: FilterDefn[];
};

export const FilterGroup = ({
    title,
    hideDivider,
    type,
    options,
}: FilterGroupProps): JSX.Element => {
    return (
        <div>
            <When condition={title}>
                <Title title={title!} />
            </When>
            <When condition={type === 'multiList'}>
                <MultiList options={options} />
            </When>
            <When condition={type === 'nestedMultiList'}>
                <NestedMultiList options={options} />
            </When>
            <Unless condition={hideDivider}>
                <Divider className="FilterDivider" />
            </Unless>
        </div>
    );
};
